import { render, staticRenderFns } from "./AdContainer.vue?vue&type=template&id=94c2e90a&scoped=true&"
import script from "./AdContainer.vue?vue&type=script&lang=js&"
export * from "./AdContainer.vue?vue&type=script&lang=js&"
import style0 from "./AdContainer.vue?vue&type=style&index=0&id=94c2e90a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "94c2e90a",
  null
  
)

export default component.exports